// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gkzECz1g9w5rbn {
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--ds-space-100, 8px);
}
.gkzECz1g9w5rbn.wTNBrMBMiZ2xA3 {
  width: unset;
  padding: var(--ds-space-150, 12px) var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-150, 12px);
}
.czlCh9zK19CCvt {
  position: relative;
  flex: 1;
}
.pKH9_su9vNXM_X {
  width: 100%;
}
.aV22xM9DQ2qOsx {
  position: absolute;
  top: var(--ds-space-050, 4px);
  right: var(--ds-space-050, 4px);
  height: 28px;
  padding: var(--ds-space-050, 4px);
  border: none;
  background: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `gkzECz1g9w5rbn`,
	"panel": `wTNBrMBMiZ2xA3`,
	"search": `czlCh9zK19CCvt`,
	"searchInput": `pKH9_su9vNXM_X`,
	"clearButton": `aV22xM9DQ2qOsx`
};
export default ___CSS_LOADER_EXPORT___;
